var _path, _path2, _g, _path3, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagsFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8023_9851)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8023_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8023_9851)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8023_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8023_9851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "#CurrentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_8023_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 14,
    height: 14
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 5H5V19H19V5Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_8023_9851)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.34198 12.362C4.55764 13.114 5.13721 13.6936 6.29636 14.8527L7.66859 16.2249C9.68533 18.2416 10.6937 19.25 11.9467 19.25C13.1998 19.25 14.2081 18.2416 16.2249 16.2249C18.2416 14.2081 19.25 13.1998 19.25 11.9467C19.25 10.6937 18.2416 9.68533 16.2249 7.66859L14.8527 6.29636C13.6936 5.13721 13.114 4.55764 12.362 4.34198C11.6101 4.12632 10.8114 4.31062 9.21406 4.67923L8.29293 4.89181C6.9491 5.20192 6.27719 5.35698 5.81708 5.81708C5.35698 6.27719 5.20192 6.94911 4.89181 8.29293L4.67923 9.21406C4.31062 10.8114 4.12632 11.6101 4.34198 12.362ZM10.3426 8.20324C10.9333 8.79392 10.9333 9.75162 10.3426 10.3423C9.75186 10.933 8.79416 10.933 8.20347 10.3423C7.61278 9.75162 7.61278 8.79392 8.20347 8.20324C8.79416 7.61254 9.75186 7.61254 10.3426 8.20324ZM17.0383 11.7883L11.8041 17.0227C11.5844 17.2424 11.2282 17.2424 11.0086 17.0227C10.7889 16.8031 10.7889 16.447 11.0086 16.2273L16.2428 10.9928C16.4625 10.7731 16.8187 10.7731 17.0383 10.9928C17.258 11.2125 17.258 11.5687 17.0383 11.7883Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8023_9851"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagsFilter);
export default __webpack_public_path__ + "static/media/Tags-Filter.57f01839b4b2802febb0c2d72eca8fb2.svg";
export { ForwardRef as ReactComponent };